import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import { makeStyles, createStyles } from '@material-ui/core/styles';
import React from 'react';

const useStyles = makeStyles(
  (theme) => createStyles({
    formControl: {
      margin: theme.spacing(1),
      minWidth: 120
    },
    selectEmpty: {
      marginTop: theme.spacing(2)
    }
  })
);
const renderItems = (items) => {
  return items.map((item) => {
    return /* @__PURE__ */ React.createElement(MenuItem, { value: item.value, key: item.label }, item.label);
  });
};
const SelectComponent = ({
  value,
  items,
  label,
  onChange
}) => {
  const classes = useStyles();
  const handleChange = (event) => {
    const val = event.target.value;
    onChange(val);
  };
  return /* @__PURE__ */ React.createElement(
    FormControl,
    {
      variant: "outlined",
      className: classes.formControl,
      disabled: items.length === 0
    },
    /* @__PURE__ */ React.createElement(InputLabel, null, label),
    /* @__PURE__ */ React.createElement(Select, { label, value, onChange: handleChange }, renderItems(items))
  );
};

export { SelectComponent };
//# sourceMappingURL=Select.esm.js.map
